import { useState, useCallback, useEffect } from 'react';

// routes
import { useParams, useHistory } from 'react-router-dom';

// helpers
import { isValidPhoneNumber } from 'libphonenumber-js';

// components
import PhoneInput from '../../../components/Inputs/PhoneInput';
import Button from '../../../components/Buttons/Button';

// styles
import styles from '../styles.module.scss';

// redux
import { useSelector } from 'react-redux';
import { selectIsLoading } from '../../../redux/selectors/miscellaneous';
import { getCountryCode } from '../../../utils/countryCode';
import UILink from '../../../components/Buttons/UILink';
import FlexColumn from '../../../components/FlexBox/FlexColumn';
import Typography from '../../../components/Typography/Typography';
import SButton from '../../../components/SButton/SButton';
import routes from '../../../constants/routes';
import useIsMobile from '../../../hooks/useIsMobile';

const RecoverPasswordForm = ({ handleSubmitOtp }) => {

  const history = useHistory();
  const isMobile = useIsMobile();
  const { phoneNumber } = useParams();

  const [countryCode, setCountryCode] = useState('91');
  const [mobileNumber, setMobileNumber] = useState({
    value: phoneNumber || '',
    error: '',
  });
  const isLoading = useSelector(selectIsLoading);

  const disabled = mobileNumber.value === '' || mobileNumber.error !== '' || isLoading;

  useEffect(() => {
    try {
      const code = getCountryCode();
      if (code) setCountryCode(code?.countryCode);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handlesubmit = useCallback(
    (e) => {
      if (!disabled) {
        handleSubmitOtp({ phoneNumber: `+${countryCode}${mobileNumber.value}` });
      }
    },
    [countryCode, disabled, handleSubmitOtp, mobileNumber.value],
  );

  const handleChange = useCallback(
    (e) => {
      const { name, value } = e?.currentTarget;
      const errorText = 'Please enter a valid';
      if (name === 'phoneNumber') {
        const error = !isValidPhoneNumber(`+${countryCode}${value}`)
          ? `${errorText} Phone Number`
          : '';
        setMobileNumber({ value, error });
      }
    },
    [countryCode],
  );

  return (
    <FlexColumn alignItems='start' styles={{ marginTop: '1rem' }} className={styles['login-form-container']}>
      <Typography variant={"b1M"}>Recover Password</Typography>
      <PhoneInput
        name="phoneNumber"
        placeholder="Phone Number"
        type="number"
        value={mobileNumber.value}
        onChange={handleChange}
        error={mobileNumber.error}
        handleCountryCode={(code) => setCountryCode(code)}
      />

      <SButton style={{ marginTop: '1rem' }} fullWidth variant={"primary"} color={"info"} onClick={handlesubmit} disabled={disabled}>SEND OTP</SButton>
      <UILink
        style={{ marginLeft: isMobile ? '1rem' : '0', transition: 'none' }}
        text="Login"
        disabled={false}
        handleSubmit={() => history.push(routes.public.login)}
      />
    </FlexColumn>
  );
};

export default RecoverPasswordForm;
